import { render, staticRenderFns } from "./TestQuestionFilterByProductGroup.vue?vue&type=template&id=b5915716&scoped=true&"
import script from "./TestQuestionFilterByProductGroup.vue?vue&type=script&lang=js&"
export * from "./TestQuestionFilterByProductGroup.vue?vue&type=script&lang=js&"
import style0 from "./TestQuestionFilterByProductGroup.vue?vue&type=style&index=0&id=b5915716&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5915716",
  null
  
)

export default component.exports